<template>
  <FormStepperControls :is-pending="formPending" v-bind="$attrs" />
</template>

<script>
import { mapGetters } from 'vuex'

import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'

import FormStepperControls from '../FormStepperControls.vue'

export default {
  name: 'ComplaintFormStepperControls',
  components: {
    FormStepperControls,
  },
  computed: {
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      formPending: FORM_GETTER.FORM_PENDING,
    }),
  },
}
</script>
